import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountsService } from '../../services/accounts.service';
import { AuthenticationService } from '../../authentication.service';
import { CustomValidators  } from '../../validators/custom-validators.validator';
import { FlashService } from '../../flash/flash.service';
import { ErrorService } from '../../services/error.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {Location} from '@angular/common';
import {INgxMyDpOptions} from 'ngx-mydatepicker';
import { SkillService } from '../../skill-matrix/services/skill.service';
import { Department } from '../../skill-matrix/api-interfaces';
import { Subject, Observable } from 'rxjs';


@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent implements OnInit {
  departmentList: Observable<Department[]>

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private accountService: AccountsService,
    private authenticationService: AuthenticationService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private errorService: ErrorService,
    private skillService: SkillService

  ) { }

  accountForm: FormGroup;
  user: any = {};
  accounts_roles_attributes = [];
  roles;
  manager_role_id;
  emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}';
  errors;

  myOptions: INgxMyDpOptions = {
    dateFormat: 'mmm dd, yyyy',
    showTodayBtn: false,
    yearSelector: false,
    sunHighlight: false,
    showSelectorArrow: false,
    alignSelectorRight: false,
    firstDayOfWeek: 'su'
  };
  ngOnInit() {
    this.departmentList = this.skillService.getDepartment();

    /* Building form for creating Accounts */
    const date = new Date();
    this.accountForm = this.formBuilder.group({
      'emp_id': new FormControl('', [Validators.required]),
      'joining_date': [this.stringToDate(date), Validators.required],
      'name': new FormControl('', [Validators.required]),
      'email': new FormControl('', [Validators.required, CustomValidators.vaildEmail]),
      'manager': new FormControl(''),
      'blog_manager': new FormControl(''),
      'is_asset_enabled': new FormControl(''),
      'is_timesheet_enabled': new FormControl(''),
      'is_timesheet_manager': new FormControl(''),
      'is_invoice_enabled': new FormControl(''),
      'is_recruitment_enabled': new FormControl(''),
      'is_work_from_home_manager': new FormControl(''),
      'is_cox_member': new FormControl(''),
      'reimbursement_manager': new FormControl(''),
      // 'manager': new FormControl('')
      'department_id':  new FormControl('', Validators.required)
    });

    /* Getting all the roles for the account */
    this.authenticationService.getRoles().subscribe(
      data => {
        this.roles = data['result'];
        for (let i = 0; i < this.roles.length; i++) {
          if (this.roles[i].name === 'manager') {
            this.manager_role_id = this.roles[i].id;
          }
        }
      },
      error => {
        this.errorService.errorHandling(error);
      }
    );
    }

  /* Creating the Account */
  onSubmit(formData) {
    this.spinnerService.show();
    if (formData.manager) {
      this.accounts_roles_attributes.push({
        'role_id': this.manager_role_id
      });
    }
    formData.department_id = Number(formData.department_id);
    formData.accounts_roles_attributes = this.accounts_roles_attributes;
    formData.joining_date = this.dateToString(formData.joining_date);
    delete formData.manager;
    this.user.account = formData;
    this.accountService.createAccount(this.user).subscribe(
      data => {
        this.spinnerService.hide();
        if (data.body['success']) {
          this.flashService.show(data.body['message'], 'alert-success');
          this.router.navigateByUrl('accounts');
        } else {
          this.errors = data.body['result'];
          this.flashService.show(data.body['message'], 'alert-danger');
        }
      },
      error => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }

  locationBack() {
    this.location.back();
  }

  stringToDate(value) {
    const dateObject = { date: { year: value.getFullYear(),
      month: (value.getMonth() + 1), day: (value.getDate()) } };
      return dateObject;
  }

  dateToString(value) {
    const dateString =  value.date.year + '-' +
    (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
     (value.date.day < 10 ? '0' : '') + value.date.day;
     return dateString;
  }

  trackByFn(index) {
    return index;
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accounts/create/create-account.component.ts